<template>
   <div></div>
</template>

<script>
   export default {
      name: 'a-data-grid',

      props: {
         value: {
            required: false
         },
         api: {
            type: String,
            required: false,
            default: 'dataService'
         },
         obj: {
            type: String,
            required: false
         },
         objId: {
            type: Number,
            required: false
         },
         filterBy: {
            type: Object,
            required: false
         },
         data: {
            type: Array,
            required: false,
            default: () => []
         },
         dataKey: {
            type: String,
            required: false,
            default: 'id'
         },
         columns: {
            type: Array,
            required: false,
            default: null
         },
         options: {
            type: Object,
            required: false
         },
         summary: {
            type: Array,
            required: false
         },
         summarySelect: {
            type: Array,
            required: false
         },
         height: {
            required: false,
            default: 250
         },
         multiSelect: {
            type: Boolean,
            required: false,
            default: false
         }

      },

      data: function () {
         return {
            tHandler: null,
            gridInstance: null,
            inputValue: null,
            gridData: null,
            batchData: []
         };
      },

      watch: {
         value (val) {
            // if (this.inputKey === this.inputValue && this.suggestions && this.suggestions.length) {
            //   this.doSelect(this.suggestions[0]);
            // }
            this.inputValue = val;
         },
         inputValue (val) {
            this.$emit('input', val);
         },
         filterBy: {
            handler: function (newFilter, oldFilter) {
               if (this.gridInstance && !this.$util.sameObject(newFilter, oldFilter)) {
                  if ((newFilter.hasOwnProperty('apply') && newFilter.apply) || (!newFilter.hasOwnProperty('apply'))) {
                     this.gridInstance.refresh();
                     newFilter.apply = false;
                  }
               }
            }
         },
         data () {
            if (!this.obj) {
               this.refresh();
            }
         },
         dataKey (val) {
            console.log('datakey watch');
            if (this.gridInstance) {
               let ds = this.gridInstance.getDataSource();
               console.log(ds);
            }
         },
         columns (val) {
            if (this.gridInstance) {
               this.gridInstance.option('columns', val);
            }
         }
      },

      methods: {
         restartSelection () {
            let total = {};

            if (this.summarySelect) {
               this.summarySelect.forEach((col) => {
                  total[col] = 0;
               });

               this.$emit('onSelectionChange', total);

            }
            return total;
         },

         save () {
            this.gridInstance.saveEditData();
         },

         refresh () {
            // console.log(this.gridInstance);
            this.gridInstance.clearSelection();
            this.gridInstance.refresh();
         },

         repaint () {
            this.gridInstance.repaint();
         }

      },

      mounted () {
         function summaryOptions (cols, selected) {
            if (!cols) return;

            let sumItems = [];
            let options = {};

            cols.forEach((col) => {
               if (typeof col === 'object') {
                  sumItems.push(col);

               } else if (typeof col === 'string') {
                  let option = col.split('|');
                  let type = option[1] || 'sum';

                  sumItems.push({
                     name: option[0],
                     column: option[0],
                     valueFormat: (type === 'count') ? '' : 'fixedPoint',
                     summaryType: type
                  });

               } else {
                  console.error(`Summary must be either a string or an object: ${item}`);
               }
            });

            options.totalItems = sumItems;

            /*options.calculateCustomSummary = function (option) {
              console.log('calc', option);

              /!*if (option.summaryProcess === "start") {
                option.totalValue = [0, 0];
              }
              if (option.summaryProcess === "calculate") {
                option.totalValue = [option.totalValue[0] + (option.value.L12GMNumber || 0), option.totalValue[1] + (option.value.L12Revenue || 0)];
              }
              if (options.summaryProcess === "finalize") {
                option.totalValue = option.totalValue[0] / option.totalValue[1];
              }*!/

            };*/

            //isRowSelected(key)

            return options;


         }

         let self = this;
         let h = this.height;

         let sumCols = summaryOptions(this.summary, this.summarySelect);

         /* if (self.columns) {
             self.columns.map(col => col.cssClass = ' vertAlignMiddle ');
          }*/

         let dataSource = new DevExpress.data.CustomStore({
            key: self.dataKey,
            onLoaded: (data) => {
               this.$emit('onDataLoaded', JSON.parse(JSON.stringify(data)));
            },
            load: (loadOptions) => {
               let params = {};

               params.filterBy = loadOptions.filter ? loadOptions.filter : self.filterBy;
               params.sortBy = loadOptions.sort ? loadOptions.sort : '';
               params.skipBy = loadOptions.skip;
               params.pgQty = (this.gridInstance) ? this.gridInstance.pageSize : 12;

               return new Promise((resolve, reject) => {
                  if (self.obj) {
                     // console.log('Loading DataGrid from Api Obj');
                     self.$api[self.api].search(self.obj, params)
                        .then(
                           (data) => {
                              self.gridData = (typeof data === 'object' && data !== null && data.hasOwnProperty('main')) ? (data.main || []) : (data || []);
                              // console.log((typeof data === 'object' && data !== null && data.hasOwnProperty('main')) ? (data.main || []) : (data || []));
                              resolve(self.gridData, { totalCount: (self.gridData.length && self.gridData[0].totalCount) ? self.gridData[0].totalCount : ((self.gridData) ? self.gridData.length : 0) });
                              self.$emit('onDataLoaded', JSON.parse(JSON.stringify(data)));
                           })
                        .catch((err) => reject(err));
                  } else {
                     // console.log('Loading DataGrid from Data Prop');
                     let data = JSON.parse(JSON.stringify(self.data)) || [];
                     resolve(data, { totalCount: (data && data.length) ? ((data[0].totalCount) ? data[0].totalCount : 0) : 0 });
                  }

               });

            },
            update: (key, data) => {
               let emitUpdate = () => {
                  self.$emit('onUpdate', JSON.parse(JSON.stringify(this.batchData)));
                  clearTimeout(this.tHandler);
               };
               this.batchData.push({
                  key,
                  data
               });
               if (this.tHandler) clearTimeout(this.tHandler);
               this.tHandler = setTimeout(emitUpdate, 50);
            }
         });

         function gridOptions () {
            return {
               dataSource: dataSource,
               columns: self.columns,
               columnMinWidth: 40,
               noDataText: 'Nada encontrado!',
               allowColumnReordering: false,
               loadPanel: {
                  text: 'carregando...'
               },
               rowAlternationEnabled: true,
               hoverStateEnabled: false,
               columnHidingEnabled: false,
               sorting: {
                  mode: 'single'
               },
               height: h,
               editing: {
                  allowAdding: false,
                  allowUpdating: false,
                  allowDeleting: false,
                  texts: {
                     addRow: 'New' + self.title,
                     saveRowChanges: 'OK'
                  }
               },
               scrolling: {
                  mode: 'virtual',
                  preloadEnabled: false
               },
               pager: {
                  visible: false
               },
               selection: {
                  mode: (self.multiSelect) ? 'multiple' : 'single',
                  allowSelectAll: self.multiSelect,
                  showCheckBoxesMode: 'always'
               },
               filterRow: {
                  showOperationChooser: false,
                  visible: false
               },
               remoteOperations: {
                  filtering: false,
                  grouping: false,
                  paging: false,
                  sorting: false,
                  summary: false
               },

               summary: sumCols,

               onRowClick: function (e) {
                  if (e.rowType === 'data') {
                     self.$emit('onRowClick', e.key);
                  }
               },

               onSelectionChanged: function (selectedItems) {

                  let data = JSON.parse(JSON.stringify(selectedItems.selectedRowsData));
                  let keys = selectedItems.selectedRowKeys;

                  let selectedTotals = self.restartSelection();

                  if (self.summarySelect) {
                     data.forEach((row) => {
                        self.summarySelect.forEach((col) => {
                           selectedTotals[col] += row[col];
                        });
                     });
                  }

                  selectedTotals.count = data.length;

                  self.inputValue = keys;
                  self.$emit('onSelectionChange', {
                     data,
                     keys,
                     selectedTotals
                  });

               },

               onRowPrepared: function (e) {
                  // console.log(e);
                  if (self.options && self.options.rowHeight && e.rowType === 'data') {
                     e.rowElement.css({ height: +self.options.rowHeight });
                  }
               },

               onContextMenuPreparing: function (e) {
                  if (e.target === 'content') {
                     self.$emit('onContentMenu', e);
                  } else if (e.target === 'header') {
                     self.$emit('onHeaderMenu', e);
                  } else if (e.target === 'footer') {
                     self.$emit('onFooterMenu', e);
                  }
               }

            };
         }

         let options = Object.assign({}, gridOptions(), this.options || {});

         // console.log(options);

         this.$nextTick(() => {
            this.gridInstance = $(this.$el).dxDataGrid(options).dxDataGrid('instance');
            if (options.selection.mode === 'multiple') {
               this.gridInstance.columnOption('command:select', 'width', 40);
               this.gridInstance.updateDimensions();
            }
            this.restartSelection();
         });

         // console.log('Grid Instance: ', this.gridInstance);

      }

   };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/ADataGrid.vue